<user-admin>
  <div class="container mt-4">
    <!-- Page Header -->
    <page-header
      title={ state.userId ? 'Editar Usuario' : 'Crear Nuevo Usuario' }
      subtitle={ state.userId ? 'Modifica los datos del usuario existente' : 'Completa la información para crear un nuevo usuario' }
      onback={ handleBack }>
    </page-header>

    <!-- Loading state -->
    <loading-spinner
      if={ state.loading }
      message={ state.userId ? 'Cargando datos del usuario...' : 'Procesando...' } />

    <!-- Error state -->
    <error-alert
      if={ state.error }
      message={ state.errorMessage }
      onretry={ loadUser } />

    <!-- Form -->
    <div if={ !state.loading && !state.error }>
      <form onsubmit={ handleSubmit } novalidate>
        <!-- Información básica -->
        <div class="card mb-4">
          <div class="card-header">
            <h5 class="mb-0">Información Básica</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="username" class="form-label">Nombre de Usuario <span class="text-danger">*</span></label>
                  <input type="text" class="form-control { state.errors['username'] ? 'is-invalid' : '' }" id="username" name="username" value={ state.formData.username } onchange={ handleInputChange }>
                  <div class="invalid-feedback" if={ state.errors['username'] }>{ state.errors['username'] }</div>
                  <div class="form-text">Nombre único para identificar al usuario</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="email" class="form-label">Correo Electrónico <span class="text-danger">*</span></label>
                  <input type="email" class="form-control { state.errors['email'] ? 'is-invalid' : '' }" id="email" name="email" value={ state.formData.email } onchange={ handleInputChange }>
                  <div class="invalid-feedback" if={ state.errors['email'] }>{ state.errors['email'] }</div>
                  <div class="form-text">Email del usuario para autenticación</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="role" class="form-label">Rol <span class="text-danger">*</span></label>
                  <select class="form-select { state.errors['role'] ? 'is-invalid' : '' }" id="role" name="role" value={ state.formData.role } onchange={ handleInputChange }>
                    <option value="">-- Seleccionar Rol --</option>
                    <option value="user">Usuario</option>
                    <option value="admin">Administrador</option>
                  </select>
                  <div class="invalid-feedback" if={ state.errors['role'] }>{ state.errors['role'] }</div>
                  <div class="form-text">Rol que determinará los permisos del usuario</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="createDevice" name="acl.createDevice" checked={ state.formData.acl.createDevice } onchange={ handleCheckboxChange }>
                    <label class="form-check-label" for="createDevice">
                      Permitir crear dispositivos
                    </label>
                    <div class="form-text">Permiso especial para crear nuevos dispositivos</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Contraseña -->
        <div class="card mb-4">
          <div class="card-header">
            <h5 class="mb-0">{ state.userId ? 'Cambiar Contraseña' : 'Contraseña' }</h5>
          </div>
          <div class="card-body">
            <div if={ state.userId } class="alert alert-info">
              <i class="bi bi-info-circle me-2"></i>
              Deja estos campos vacíos si no deseas cambiar la contraseña.
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="password" class="form-label">
                    { state.userId ? 'Nueva Contraseña' : 'Contraseña' }
                    <span class="text-danger" if={ !state.userId }>*</span>
                  </label>
                  <input type="password" class="form-control { state.errors['password'] ? 'is-invalid' : '' }" id="password" name="password" value={ state.formData.password } onchange={ handleInputChange }>
                  <div class="invalid-feedback" if={ state.errors['password'] }>{ state.errors['password'] }</div>
                  <div class="form-text">Mínimo 6 caracteres</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="confirmPassword" class="form-label">
                    Confirmar { state.userId ? 'Nueva ' : '' }Contraseña
                    <span class="text-danger" if={ !state.userId }>*</span>
                  </label>
                  <input type="password" class="form-control { state.errors['confirmPassword'] ? 'is-invalid' : '' }" id="confirmPassword" name="confirmPassword" value={ state.formData.confirmPassword } onchange={ handleInputChange }>
                  <div class="invalid-feedback" if={ state.errors['confirmPassword'] }>{ state.errors['confirmPassword'] }</div>
                  <div class="form-text">Debe coincidir con la contraseña anterior</div>
                </div>
              </div>
            </div>
            <div if={ state.userId } class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="currentPassword" class="form-label">Contraseña Actual</label>
                  <input type="password" class="form-control { state.errors['currentPassword'] ? 'is-invalid' : '' }" id="currentPassword" name="currentPassword" value={ state.formData.currentPassword } onchange={ handleInputChange }>
                  <div class="invalid-feedback" if={ state.errors['currentPassword'] }>{ state.errors['currentPassword'] }</div>
                  <div class="form-text">Requerida solo si cambias la contraseña</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Card: Configuración Sentilo/Dival -->
        <div class="card mb-4">
          <div class="card-header">
            <h5 class="mb-0">Configuración Sentilo/Dival</h5>
          </div>
          <div class="card-body">
            <div class="alert alert-info">
              <i class="bi bi-info-circle me-2"></i>
              Configura la integración con Sentilo para notificar aperturas de puertas a la plataforma Dival.
            </div>

            <div class="mb-3">
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="sentiloEnabled"
                  name="sentiloConfig.enabled"
                  checked={ state.formData.sentiloConfig.enabled }
                  onchange={ handleCheckboxChange }>
                <label class="form-check-label" for="sentiloEnabled">
                  <strong>Habilitar Sentilo</strong>
                </label>
              </div>
            </div>

            <div if={ state.formData.sentiloConfig.enabled }>
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="sentiloToken" class="form-label">Token <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      class="form-control font-monospace { state.errors['sentiloConfig.token'] ? 'is-invalid' : '' }"
                      id="sentiloToken"
                      name="sentiloConfig.token"
                      value={ state.formData.sentiloConfig.token }
                      onchange={ handleInputChange }
                      placeholder="XXXXXXXXXXXXXXXXXXXXXXXXXX">
                    <div class="invalid-feedback" if={ state.errors['sentiloConfig.token'] }>{ state.errors['sentiloConfig.token'] }</div>
                    <div class="form-text">Token de autenticación proporcionado por Dival</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="sentiloProviderId" class="form-label">Provider ID <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      class="form-control { state.errors['sentiloConfig.providerId'] ? 'is-invalid' : '' }"
                      id="sentiloProviderId"
                      name="sentiloConfig.providerId"
                      value={ state.formData.sentiloConfig.providerId }
                      onchange={ handleInputChange }
                      placeholder="ciudad@proveedor">
                    <div class="invalid-feedback" if={ state.errors['sentiloConfig.providerId'] }>{ state.errors['sentiloConfig.providerId'] }</div>
                    <div class="form-text">Identificador del proveedor (ej: bocairent@discomon)</div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="sentiloEntityCode" class="form-label">Código Entidad</label>
                    <input
                      type="text"
                      class="form-control"
                      id="sentiloEntityCode"
                      name="sentiloConfig.entityCode"
                      value={ state.formData.sentiloConfig.entityCode }
                      onchange={ handleInputChange }
                      placeholder="BOT">
                    <div class="form-text">Código de la entidad (opcional)</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Card: Configuración Innobing -->
        <div class="card mb-4">
          <div class="card-header">
            <h5 class="mb-0">Integración Innobing</h5>
          </div>
          <div class="card-body">
            <div class="alert alert-info">
              <i class="bi bi-info-circle me-2"></i>
              Configura la integración con Innobing. Cada usuario puede apuntar a una instancia distinta (URL base y token propios).
            </div>

            <div class="mb-3">
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="innobingEnabled"
                  name="innobingConfig.enabled"
                  checked={ state.formData.innobingConfig.enabled }
                  onchange={ handleCheckboxChange }>
                <label class="form-check-label" for="innobingEnabled">
                  <strong>Habilitar Innobing</strong>
                </label>
              </div>
            </div>

            <div if={ state.formData.innobingConfig.enabled }>
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="innobingBaseUrl" class="form-label">URL Base <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      class="form-control { state.errors['innobingConfig.baseUrl'] ? 'is-invalid' : '' }"
                      id="innobingBaseUrl"
                      name="innobingConfig.baseUrl"
                      value={ state.formData.innobingConfig.baseUrl }
                      onchange={ handleInputChange }
                      placeholder="https://miinstancia.innobing.net">
                    <div class="invalid-feedback" if={ state.errors['innobingConfig.baseUrl'] }>{ state.errors['innobingConfig.baseUrl'] }</div>
                    <div class="form-text">URL base de la instancia Innobing del usuario</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="innobingToken" class="form-label">Token <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      class="form-control font-monospace { state.errors['innobingConfig.token'] ? 'is-invalid' : '' }"
                      id="innobingToken"
                      name="innobingConfig.token"
                      value={ state.formData.innobingConfig.token }
                      onchange={ handleInputChange }
                      placeholder="XXXXXXXXXXXXXXXXXXXXXXXXXX">
                    <div class="invalid-feedback" if={ state.errors['innobingConfig.token'] }>{ state.errors['innobingConfig.token'] }</div>
                    <div class="form-text">Token Bearer de autenticación de Innobing</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Botones de acción -->
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-end gap-2">
              <button type="button" class="btn btn-outline-secondary app-btn app-btn-md" onclick={ handleBack }>
                Cancelar
              </button>
              <button type="submit" class="btn btn-primary app-btn app-btn-md" disabled={ state.saving }>
                <span if={ state.saving } class="spinner-border spinner-border-sm me-2" role="status"></span>
                { state.userId ? 'Actualizar Usuario' : 'Crear Usuario' }
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <script>
    import PageHeader from './page-header.riot'
    import LoadingSpinner from './loading-spinner.riot'
    import ErrorAlert from './error-alert.riot'
    import { UserService, AuthService } from '../services/api-service'
    import { ToastService } from '../services/toast-service'

    export default {
      components: {
        PageHeader,
        LoadingSpinner,
        ErrorAlert
      },
      onBeforeMount() {
        // Obtener el ID del usuario desde la URL si existe
        const urlParams = new URLSearchParams(window.location.search)
        const userId = urlParams.get('id')

        this.state = {
          userId: userId,
          loading: !!userId, // Solo cargar si hay ID (modo edición)
          error: false,
          errorMessage: '',
          saving: false,
          errors: {},
          formData: this.getInitialFormData()
        }
      },

      async onMounted() {
        // Verificar permisos de administrador
        if (!AuthService.isAdmin()) {
          this.update({
            error: true,
            errorMessage: 'Acceso denegado. Debes ser administrador para acceder a esta sección.'
          })
          return
        }

        // Si hay userId, cargar los datos del usuario
        if (this.state.userId) {
          await this.loadUser()
        }
      },

      getInitialFormData() {
        return {
          username: '',
          email: '',
          role: '',
          password: '',
          confirmPassword: '',
          currentPassword: '',
          acl: {
            createDevice: false
          },
          sentiloConfig: {
            enabled: false,
            token: '',
            providerId: '',
            entityCode: ''
          },
          innobingConfig: {
            enabled: false,
            baseUrl: '',
            token: ''
          }
        }
      },

      mapUserToFormData(user) {
        return {
          username: user.username || '',
          email: user.email || '',
          role: user.roles && user.roles.length > 0 ? user.roles[0] : '',
          password: '',
          confirmPassword: '',
          currentPassword: '',
          acl: {
            createDevice: user.acl?.createDevice || false
          },
          sentiloConfig: {
            enabled: user.sentiloConfig?.enabled || false,
            token: user.sentiloConfig?.token || '',
            providerId: user.sentiloConfig?.providerId || '',
            entityCode: user.sentiloConfig?.entityCode || ''
          },
          innobingConfig: {
            enabled: user.innobingConfig?.enabled || false,
            baseUrl: user.innobingConfig?.baseUrl || '',
            token: user.innobingConfig?.token || ''
          }
        }
      },

      async getUserDataForEdit(userId) {
        const currentUserId = AuthService.getUserId()
        const isEditingOwnAccount = currentUserId === userId

        if (isEditingOwnAccount) {
          return UserService.getUserById(userId)
        }

        const users = await UserService.getUsers()
        const targetUser = (users || []).find(user => user._id === userId)

        if (!targetUser) {
          throw new Error('Usuario no encontrado en el listado de administración')
        }

        return targetUser
      },

      async loadUser() {
        if (!this.state.userId) return

        try {
          this.update({ loading: true, error: false })

          const user = await this.getUserDataForEdit(this.state.userId)

          // Mapear los datos del usuario al formulario
          this.update({
            formData: this.mapUserToFormData(user),
            loading: false
          })
        } catch (error) {
          console.error('Error loading user:', error)
          this.update({
            loading: false,
            error: true,
            errorMessage: `Error al cargar el usuario: ${error.message || 'Error desconocido'}`
          })
        }
      },

      handleInputChange(e) {
        const { name, value } = e.target
        const errors = this.clearError(name)

        if (name.includes('.')) {
          // Manejar campos anidados como acl.createDevice o sentiloConfig.token
          const parts = name.split('.')

          if (parts.length === 2) {
            const [parent, child] = parts
            this.update({
              errors,
              formData: {
                ...this.state.formData,
                [parent]: {
                  ...this.state.formData[parent],
                  [child]: value
                }
              }
            })
          }
        } else {
          // Manejar campos de primer nivel
          this.update({
            errors,
            formData: {
              ...this.state.formData,
              [name]: value
            }
          })
        }
      },

      // Devuelve una copia de los errores sin el campo indicado, para que la
      // marca de error desaparezca apenas el usuario corrige el dato
      clearError(name) {
        if (!this.state.errors || !this.state.errors[name]) {
          return this.state.errors
        }

        const errors = { ...this.state.errors }
        delete errors[name]
        return errors
      },

      handleCheckboxChange(e) {
        const { name, checked } = e.target

        if (name.includes('.')) {
          // Manejar campos anidados como acl.createDevice o sentiloConfig.enabled
          const parts = name.split('.')

          if (parts.length === 2) {
            const [parent, child] = parts
            this.update({
              formData: {
                ...this.state.formData,
                [parent]: {
                  ...this.state.formData[parent],
                  [child]: checked
                }
              }
            })
          }
        } else {
          // Manejar campos de primer nivel
          this.update({
            formData: {
              ...this.state.formData,
              [name]: checked
            }
          })
        }
      },

      async handleSubmit(e) {
        e.preventDefault()

        if (this.state.saving) return

        // Validaciones
        if (!this.validateForm()) {
          return
        }

        try {
          this.update({ saving: true })

          if (this.state.userId) {
            // Actualizar usuario existente
            const updateData = {
              username: this.state.formData.username,
              email: this.state.formData.email,
              role: this.state.formData.role,
              sentiloConfig: this.state.formData.sentiloConfig,
              innobingConfig: this.state.formData.innobingConfig
            }

            // Solo agregar contraseñas si se proporcionaron
            if (this.state.formData.password) {
              updateData.newPassword = this.state.formData.password
              updateData.currentPassword = this.state.formData.currentPassword
            }

            await UserService.updateUser(this.state.userId, updateData)
            ToastService.success('Usuario actualizado correctamente')
          } else {
            // Crear nuevo usuario
            const createData = {
              username: this.state.formData.username,
              email: this.state.formData.email,
              password: this.state.formData.password
            }

            await UserService.createUser(createData)
            ToastService.success('Usuario creado correctamente')

            // Solo redirigir cuando se crea un nuevo usuario
            this.handleBack()
          }

        } catch (error) {
          console.error('Error saving user:', error)
          ToastService.error(`Error al ${this.state.userId ? 'actualizar' : 'crear'} el usuario: ${error.message || 'Error desconocido'}`)
        } finally {
          this.update({ saving: false })
        }
      },

      validateForm() {
        const { username, email, password, confirmPassword, role, sentiloConfig, innobingConfig } = this.state.formData
        const errors = {}

        // Datos básicos
        if (!username.trim()) {
          errors.username = 'El nombre de usuario es requerido'
        }

        if (!email.trim()) {
          errors.email = 'El correo electrónico es requerido'
        } else {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
          if (!emailRegex.test(email)) {
            errors.email = 'El formato del correo electrónico no es válido'
          }
        }

        if (!role) {
          errors.role = 'Debes seleccionar un rol'
        }

        // Contraseña: obligatoria al crear, opcional al editar
        if (!this.state.userId) {
          if (!password) {
            errors.password = 'La contraseña es requerida'
          } else if (password.length < 6) {
            errors.password = 'La contraseña debe tener al menos 6 caracteres'
          }

          if (!confirmPassword) {
            errors.confirmPassword = 'Debes confirmar la contraseña'
          } else if (password && password !== confirmPassword) {
            errors.confirmPassword = 'Las contraseñas no coinciden'
          }
        } else {
          if (password && password.length < 6) {
            errors.password = 'La nueva contraseña debe tener al menos 6 caracteres'
          }

          if (password && password !== confirmPassword) {
            errors.confirmPassword = 'Las contraseñas no coinciden'
          }

          if (password && !this.state.formData.currentPassword) {
            errors.currentPassword = 'Debes proporcionar tu contraseña actual para cambiarla'
          }
        }

        // Integraciones: los campos obligatorios solo se exigen cuando están habilitadas
        if (sentiloConfig.enabled) {
          if (!sentiloConfig.token.trim()) {
            errors['sentiloConfig.token'] = 'El token de Sentilo es obligatorio'
          }
          if (!sentiloConfig.providerId.trim()) {
            errors['sentiloConfig.providerId'] = 'El Provider ID de Sentilo es obligatorio'
          }
        }

        if (innobingConfig.enabled) {
          if (!innobingConfig.baseUrl.trim()) {
            errors['innobingConfig.baseUrl'] = 'La URL base de Innobing es obligatoria'
          }
          if (!innobingConfig.token.trim()) {
            errors['innobingConfig.token'] = 'El token de Innobing es obligatorio'
          }
        }

        this.update({ errors })

        if (Object.keys(errors).length > 0) {
          ToastService.error('Revisá los campos marcados en rojo')
          return false
        }

        return true
      },

      handleBack() {
        // Volver a la página principal de dispositivos
        if (this.props.onback) {
          this.props.onback()
        } else {
          // Redirigir a la gestión de usuarios limpiando los parámetros de URL
          window.history.pushState({}, '', '/users')
          window.dispatchEvent(new PopStateEvent('popstate'))
        }
      }
    }
  </script>
</user-admin>
